document.querySelectorAll('.feature-section').forEach(section => {
    const items = section.querySelectorAll('.accordion-item');
    const img = section.querySelector('.image-viewer img');

    if (!items.length || !img) return;

    img.style.transition = 'opacity 0.3s ease';

    function updateActiveItem(index) {
        const item = items[index];
        const newSrc = item.getAttribute('data-image');

        items.forEach(i => i.classList.remove('active'));
        item.classList.add('active');

        img.style.opacity = '0';

        setTimeout(() => {
            const preload = new Image();
            preload.onload = () => {
                img.src = newSrc;
                requestAnimationFrame(() => requestAnimationFrame(() => {
                    img.style.opacity = '1';
                }));
            };
            preload.src = newSrc;
        }, 200);
    }

    items.forEach((item, index) => {
        item.addEventListener('click', () => {
            if (item.classList.contains('active')) return;
            updateActiveItem(index);
        });
    });
});
